
import React from "react"
import { useTranslation } from "react-i18next"

import { Button, Modal } from "components"
import classes from "./KccmmPrompt.module.scss"

const KccmmPrompt = props => {
  const {
    onSkip,
    setOpenModal,
    openPromtModal,
    setOpenPromtModal
  } = props

  const [t] = useTranslation()

  const handleSkip = () => {
    setOpenModal(false)

    setOpenPromtModal(false)

    onSkip()
  }

  return (
    <Modal
      show={openPromtModal}
      onHide={() => setOpenPromtModal(false)}
    >
      <div className={classes["container"]}>
        <h2 className={classes["title"]}>
          {t("مشتری_گرامی_در_صورت_وارد_نکردن_شماره_همراه_اطلاع_از_وضعیت_سفارش_تنها_از_طریق_کد_QR_می_باشد")}.
          <br />
          <br />
          {t("پیشنهاد_می_شود_شماره_همراه_خود_را_وارد_نمایید")}.
        </h2>

        <div className={classes["footer"]}>
          <Button
            onClick={() => setOpenPromtModal(false)}
            color="success"
            className={classes["yes"]}
          >
            {t("بازگشت و اضافه کردن شماره همراه")}
          </Button>

          <Button
            onClick={handleSkip}
            className={classes["button"]}
            color="warning"
          >
            {t("ادامه و ثبت سفارش")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default KccmmPrompt